module.exports = __webpack_public_path__ + "img/deals.0e67cf76.svg";